/** Rejects mailto parameter injection — bare address only. */
const BARE_EMAIL_PATTERN = /^[^\s@?#]+@[^\s@?#]+\.[^\s@?#]+$/

/**
 * Returns a safe mailto address or null when the value is missing or malformed.
 */
export function sanitizeSupportMailtoAddress(email: string | null | undefined): string | null {
  if (email == null) {
    return null
  }

  const trimmed = email.trim()
  if (!trimmed || !BARE_EMAIL_PATTERN.test(trimmed)) {
    return null
  }

  return trimmed
}
